import React, { Component } from 'react';
import { request } from '../../util/APIUtils';
import { API_BASE_URL } from '../../constants';
import './OndutyList.css';
import NobetParams from "../nobetParams/NobetParams";
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import { FaHome } from "react-icons/fa";
import { FaPaperPlane } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import {Link} from "react-router-dom"
import { GrLocation } from "react-icons/gr";


class OnDutyList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nobetciEczanes: [],
      loading: false,
      error: null,
      pageSize: 10,
      currentPage: 1,
      visibleEczanes: [],
      districtFilter: "",
      selectedPharmacyLocation:'',

    };
  }

  componentDidMount() {

    this.fetchPharmacies(10, 1, this.state.districtFilter);
  }

handleDistrictFilterChange = (event) => {
  const inputValue = event.target.value;
  this.setState({ districtFilter: inputValue }, () => {
    this.fetchFilteredPharmacies();
  });
};

fetchPharmacies = (pageSize, currentPage) => {
  const self = this;
  const { districtFilter } = this.state;


  const dutyListParams = {
    url: API_BASE_URL + '/dutyparameters/getDutyList',
    params: {
      avmNobetciEczane: this.props.avmNobetciEczane || "Evet",
      nobetYuzdesi: this.props.nobetYuzdesi || 0,
      pageSize: pageSize,
      currentPage: currentPage,
    },
  };

  request(dutyListParams)
    .then(function (response) {
      if (Array.isArray(response.data)) {

        const nobetciEczanes = response.data;

        if (districtFilter) {
          const filterText = districtFilter.toLowerCase();

          const filteredEczanes = nobetciEczanes.filter(eczane => eczane.district.toLowerCase().includes(filterText));
          self.setState({ nobetciEczanes: filteredEczanes, visibleEczanes: filteredEczanes, loading: false });
        } else {

          self.setState({ nobetciEczanes, visibleEczanes: nobetciEczanes, loading: false });
        }
      } else {
        self.setState({
          loading: false,
          error: 'Lütfen Nöbetçi Eczane Listesi Oluşturmak için Parametre Belirleyin...',
        });
      }
    })
    .catch(function (error) {
      self.setState({
        loading: false,
        error: 'Lütfen Nöbetçi Eczane Listesi Oluşturmak için Parametre Belirleyin...',
        visibleEczanes: [],
      });
    });
};


  fetchFilteredPharmacies = () => {
    const { districtFilter, pageSize, currentPage } = this.state;
    this.fetchPharmacies(pageSize, currentPage, districtFilter);
  };

  handlePageSizeChange(event) {
    this.setState(
      {
        pageSize: parseInt(event.target.value),
        currentPage: 1,
      },
      () => {
        this.fetchPharmacies();
      }
    );
  }

  handlePageChange(action) {
    const { currentPage } = this.state;
    if (action === 'prev' && currentPage > 1) {
      this.setState({ currentPage: currentPage - 1 }, () => {
        this.fetchPharmacies();
      });
    } else if (action === 'next') {
      this.setState({ currentPage: currentPage + 1 }, () => {
        this.fetchPharmacies();
      });
    }
  }

  filterPharmacies = (avmNobetciEczane) => {
    const filteredPharmacies = this.state.nobetciEczanes.filter(eczane => {
      if (avmNobetciEczane === "Evet") {
        return true;
      } else if (avmNobetciEczane === "Hayır") {
        return !eczane.location.toLowerCase().includes("avm");
      }
    });
    this.setState({ nobetciEczanes: filteredPharmacies });
  };

  handleSave = () => {
    this.filterPharmacies(this.props.avmNobetciEczane);
  };

handleDistrictFilterChange = (event) => {
  const inputValue = event.target.value;
  const filterText = inputValue.toLocaleUpperCase('tr-TR');
  this.setState({ districtFilter: filterText }, () => {
    this.fetchFilteredPharmacies();
  });
};

 handleShowOnMapClick = (longitude, latitude) => {
   this.setState({
     selectedPharmacyLocation: { longitude, latitude}

   });
 };


  render() {
    const { nobetciEczanes, loading, error, pageSize, currentPage , selectedPharmacyLocation} = this.state;

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const visibleEczanes = nobetciEczanes.slice(startIndex, endIndex);

    const filterText = this.state.districtFilter.toLowerCase();
    const totalPharmacies = nobetciEczanes.length;

     const mapState = selectedPharmacyLocation
         ? { center: [selectedPharmacyLocation.longitude, selectedPharmacyLocation.latitude], zoom:  18}
         : { center: [37.15882604, 38.77394324], zoom: 12 };



    return (
      <div className="ondutypage">
        <h4>Nöbetçi Eczaneler</h4>

    <input
      type="text"
      placeholder="İlçe Ara"
      value={this.state.districtFilter}
       onChange={this.handleDistrictFilterChange}
       style={{
        padding: '10px',
           fontSize: '11px',
           border: '2px solid #ccc',
           borderRadius: '5px',

       }}
    />


       <div id="yandex-map" style={{ marginTop: '20px' }}>
                <YMaps query={{ lang: 'tr_TR', load: 'package.full' }}>
                  <Map key={JSON.stringify(mapState)} defaultState={mapState} width={'99%'} height={'400px'}>
                    {visibleEczanes ? (
                      visibleEczanes.map((item, index) => (
                        <Placemark
                          key={[item.name, index]}
                          geometry={[item.latitude, item.longitude]}
                          properties={{ hintContent: item.name, balloonContent: item.adres }}
                          onClick={() => this.handleShowOnMapClick(item.longitude, item.latitude)}
                        />
                      ))
                    ) : (
                      <p>Veri bulunamadı veya bir hata oluştu.</p>
                    )}

                  </Map>
                </YMaps>
              </div>




        <div className="on-duty-list-container">
          {loading && <p>Loading...</p>}
          {error && <p className="error-message">{error}</p>}
          <div className="eczane-container">
            {visibleEczanes.map((eczane, index) => (
              <div key={index} className="eczane-box">
                <strong style={{ fontWeight: 'bold', fontSize: '18px' }}>{eczane.name}</strong>
                <p><FaHome className="home-icon" /> {eczane.location}</p>
                <p><FaPaperPlane className="plane-icon" /> {eczane.district}</p>
                <p><FaPhone className="phone-icon" /> {eczane.phone}</p>
                 <Link onClick={() => this.handleShowOnMapClick(eczane.latitude, eczane.longitude)}>
                   <GrLocation />
                     Eczane Konumunu Göster
                 </Link>
              </div>
            ))}
          </div>
        </div>
         <div>
        <div className="pagination">
          <button className="onduty-page-button" onClick={() => this.handlePageChange('prev')} disabled={currentPage === 1}>
            Önceki
          </button>
          <span>Sayfa {currentPage} / {Math.ceil(nobetciEczanes.length / this.state.pageSize)}</span>
          <button className="onduty-page-button"  onClick={() => this.handlePageChange('next')} disabled={endIndex >= nobetciEczanes.length}>
            Sonraki
          </button>
                  <select
                      className="ondutypage-select"
                      onChange={(e) => this.handlePageSizeChange(e)} value={this.state.pageSize}
                      placeholder="10/sayfa"
                  >
                        <option value={10}>10/sayfa</option>
                        <option value={20}>20/sayfa</option>
                        <option value={30}>30/sayfa</option>
                        <option value={40}>40/sayfa</option>
                        <option value={50}>50/sayfa</option>
                        <option value={100}>100/sayfa</option>
                  </select>
        </div>
             <button type="button" data-toggle="tooltip" data-placement="bottom"
                     title="Nöbetçi Listesı Oluştur" disabled={this.state.isLoading}
                     style={{
                         background: 'linear-gradient(#2b93cd, #0a66b7)',
                         height: '40px',
                         width: '260px',
                         float: 'right',
                         marginRight: '30px',
                         color: 'white',
                         borderRadius: '0.375em',
                     }}
                     className="TekBtn add-new-member "
                     rel="tooltip"
                     onClick={() => this.props.history.push("/nobetciParams")}>
                 NÖBETÇİ ECZANE LİSTESİ OLUŞTUR
             </button>
        </div>
          <p className="total-pharmacies">Toplam Nöbetçi Eczane Sayısı: {totalPharmacies}</p>
      </div>
    );
  }
}

export default OnDutyList;



// WEBPACK FOOTER //
// ./src/page/onduty/OnDutyList.js